import React from 'react';

const ItemDetailsShortDescription = ({ shortDescription }) => (
    <div className="item_details_block_short_description">{shortDescription}</div>
);

export default ItemDetailsShortDescription;
